import { __assign } from "tslib";
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
export function startInternalContext(applicationId, session, parentContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = parentContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            if (session.isTracked() && viewContext && urlContext && viewContext.session.id) {
                var actionContext = parentContexts.findAction(startTime);
                return {
                    application_id: applicationId,
                    session_id: viewContext.session.id,
                    user_action: actionContext
                        ? {
                            id: actionContext.action.id,
                        }
                        : undefined,
                    view: __assign(__assign({}, viewContext.view), urlContext.view),
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map